/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// core
import {
  Component,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
// models
import { Footer } from '@root/shared/models/footer.interface';
import { LinkData } from '@root/shared/models/footer-link.interface';
// services
// Constants
import { PDLBaseComponent } from '@experience/reb-pdl/components/pdl.base.component';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';
import { ActivatedRoute } from '@angular/router';

/**
 * Component for the UI footer.
 * @access protected - used by the Root module
 */
@Component({
  selector: 'tmo-digital-footer',
  encapsulation: ViewEncapsulation.None, // allows for style sheet to insert global styles
  templateUrl: './digital-footer.component.html',
  styleUrls: ['../../../../../style-sheets/theme/digital-footer.scss'],
})
export class DigitalFooterComponent extends PDLBaseComponent implements OnInit, OnDestroy {
  @Input() public footerLinks: Footer;
  @Input() public footerData: Footer;
  @Output() public onMenuLinkClick: EventEmitter<LinkData>;

  // private isWebChannel: boolean;
  constructor(
    public routeSnapshot: ActivatedRoute,
    public pdlService: PdlService
  ) {
    super(pdlService, routeSnapshot);
    this.onMenuLinkClick = new EventEmitter<LinkData>();
  }

  /**
   * Load the initial configuration of footer
   * @returns void
   */
  public ngOnInit(): void {}

  public onMenuClick(href: string, newTab: boolean, name: string): boolean {
    this.onMenuLinkClick.emit({ href, newTab, name });
    return false;
  }
  /**
   * Method to destroy service data.
   * @returns void
   */
  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
